// src/components/MasteryLegend.tsx
//
// The five-tier mastery legend chips, shared by the dashboard Mastery Map and
// the Practice-by-Topic page so both views explain their colors identically.

import { MASTERY_DISPLAY } from '@/lib/test-engine/sat-domains'
import { TIER_CELL, LEGEND_ORDER } from '@/lib/scoring/mastery-display'
import { TierIcon } from '@/components/MasteryMedal'
import { masteryTierRule } from '@/lib/progress/metric-labels'

export default function MasteryLegend() {
  return (
    <div className="flex flex-wrap items-center gap-1">
      {LEGEND_ORDER.map((tier) => (
        <span
          key={tier}
          title={masteryTierRule(tier)}
          className={`inline-flex items-center gap-1 rounded border px-1.5 py-0.5 text-[10px] ${TIER_CELL[tier]}`}
        >
          <TierIcon tier={tier} className="h-3 w-3" />
          {MASTERY_DISPLAY[tier].label}
        </span>
      ))}
    </div>
  )
}
